// extracted by css-extract-rspack-plugin
export default {"newOnly":"overviewLayout-module__newOnly","oldOnly":"overviewLayout-module__oldOnly"};